import { UUID } from "crypto";

export const inventoryOperationKeys = {
  all: ["inventory-operations"] as const,
  lists: () => [...inventoryOperationKeys.all, "list"] as const,
  list: (filters?: Record<string, any>) =>
    [...inventoryOperationKeys.lists(), filters] as const,
  details: () => [...inventoryOperationKeys.all, "detail"] as const,
  detail: (id: UUID) => [...inventoryOperationKeys.details(), id] as const,
  withTransactions: (id: UUID) =>
    [...inventoryOperationKeys.detail(id), "transactions"] as const,
  fullDetails: (id: UUID) =>
    [...inventoryOperationKeys.detail(id), "full-details"] as const,
  fees: (id: UUID) => [...inventoryOperationKeys.detail(id), "fees"] as const,
};

export const inventoryTransactionKeys = {
  all: ["inventory-transactions"] as const,
  lists: () => [...inventoryTransactionKeys.all, "list"] as const,
  list: (filters?: Record<string, any>) =>
    [...inventoryTransactionKeys.lists(), filters] as const,
  byOperation: (operationId: UUID) =>
    [...inventoryTransactionKeys.all, "by-operation", operationId] as const,
  details: () => [...inventoryTransactionKeys.all, "detail"] as const,
  detail: (id: UUID) => [...inventoryTransactionKeys.details(), id] as const,
  withFlows: (id: UUID) =>
    [...inventoryTransactionKeys.detail(id), "flows"] as const,
};

export const inventoryTransferKeys = {
  all: ["inventory-transfers"] as const,
  lists: () => [...inventoryTransferKeys.all, "list"] as const,
  list: (filters?: Record<string, any>) =>
    [...inventoryTransferKeys.lists(), filters] as const,
  byStock: (stockId: UUID) =>
    [...inventoryTransferKeys.all, "by-stock", stockId] as const,
  details: () => [...inventoryTransferKeys.all, "detail"] as const,
  detail: (id: UUID) => [...inventoryTransferKeys.details(), id] as const,
  withRelations: (id: UUID) =>
    [...inventoryTransferKeys.detail(id), "relations"] as const,
};
